import { render, staticRenderFns } from "./KasPiutangForm.vue?vue&type=template&id=7f104d9b&"
import script from "./KasPiutangForm.vue?vue&type=script&lang=js&"
export * from "./KasPiutangForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports